module.exports = __webpack_public_path__ + "img/logo_1.82b9c7a5.png";